import Vue from "vue";
import Router from "vue-router";
import GroupList from "./components/GroupList.vue";
import Identity from "./components/Identity.vue";
import Scrutinio from "./components/Scrutinio.vue";
import store from "./store";
import i18n from "./i18n";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: `${i18n.locale}`
    },
    {
      path: "/:locale?",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "group",
          name: "group",
          component: GroupList,
          props: true
        },
        {
          path: "scrutinio/:id/:page",
          name: "scrutinio",
          component: Scrutinio,
          props: castRouteParams
        },
        {
          path: "",
          name: "identity",
          component: Identity,
          props: true
        }
      ]
    }
  ]
});

function castRouteParams(route) {
  return {
    id: String(route.params.id),
    page: String(route.params.page)
  };
}

router.beforeEach((to, from, next) => {
  Vue.config.lang = to.params.locale;

  let language = to.params.locale;
  if (from.params.locale != "undefined") {
    language = i18n.locale;
  }
  i18n.locale = language;

  if (to.name !== "identity" && !store.state.identityConfirmed) {
    next("");
  }

  return next();
});
export default router;
